/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePathwayTemplateDto } from '../../models/create-pathway-template-dto';
import { ResponsePathwayTemplateDto } from '../../models/response-pathway-template-dto';

export interface PathwayTemplatesControllerCreate$Params {
      body: CreatePathwayTemplateDto
}

export function pathwayTemplatesControllerCreate(http: HttpClient, rootUrl: string, params: PathwayTemplatesControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePathwayTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, pathwayTemplatesControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePathwayTemplateDto>;
    })
  );
}

pathwayTemplatesControllerCreate.PATH = '/thalea-pathways/pathway-templates';
